import {merge} from '#core/utils/config-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateSimplePopover} from '#core/application/modules/tiles/popover/index.js';
import {CLOSE_BUTTON_TYPES, generateCloseButton} from '#core/application/modules/tiles/close-button/index.js';

import BEST_ODDS_GUARANTEED_INDICATOR from './best-odds-guranteed-indicator.palette-schema.yaml';

registerTileSchema(BEST_ODDS_GUARANTEED_INDICATOR);

export function generateBestOddsGuaranteedIndicator(TILE) {
    const {FONT} = TILE;
    const {
        BEST_ODDS_GUARANTEED_POPOVER_BG,
        BEST_ODDS_GUARANTEED_POPOVER_BORDER_RADIUS,
        BEST_ODDS_GUARANTEED_POPOVER_SHADOW,
        BEST_ODDS_GUARANTEED_POPOVER_BORDER_COLOR,
    } = TILE;

    return {
        popover: {
            popup: generateSimplePopover(
                BEST_ODDS_GUARANTEED_POPOVER_BG,
                BEST_ODDS_GUARANTEED_POPOVER_BORDER_RADIUS,
                BEST_ODDS_GUARANTEED_POPOVER_SHADOW,
                BEST_ODDS_GUARANTEED_POPOVER_BORDER_COLOR
            ),
            closeButton: merge(
                generateCloseButton(TILE.BEST_ODDS_GUARANTEED_POPOVER_CLOSE_BUTTON, CLOSE_BUTTON_TYPES.COMMON),
                {
                    buttonIcon: {
                        style: {
                            width: 8,
                            height: 8,
                            minWidth: 8,
                            minHeight: 8,
                        },
                    },
                }
            ),
        },
        text: {
            style: {
                fontWeight: 500,
                fontSize: 12,
                ...TILE.BEST_ODDS_GUARANTEED_INDICATOR_LABEL_TEXT,
            },
            container: {
                whiteSpace: 'normal',
            },
        },
        bestOddsGuaranteedIcon: icon(TILE.BEST_ODDS_GUARANTEED_INDICATOR_ICON_COLOR),
        contentText: {
            style: {
                fontWeight: FONT.WEIGHT_NORMAL,
                fontSize: FONT.SIZE_MEDIUM,
                ...TILE.BEST_ODDS_GUARANTEED_POPOVER_CONTENT_TEXT,
            },
        },
    };
}
